import { GET_OTP_PVS_FAILURE, GET_OTP_PVS_REQUEST, GET_OTP_PVS_RESET, GET_OTP_PVS_SUCCESS } from "../../../redux/types/auth";

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
};

const getOTPPVSReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OTP_PVS_REQUEST:
      return {
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case GET_OTP_PVS_SUCCESS:
      return {
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      };
    case GET_OTP_PVS_FAILURE:
      return {
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      };
    case GET_OTP_PVS_RESET:
      return initialState;
    default:
      return state;
  }
};

export default getOTPPVSReducer;
